<dx-date-box
  type="date"
  displayFormat="longdate"
  #dateInput
  [attr.name]="nameString"
  [attr.tabindex]="tabIndexValue"
  placeholder="Long Date"
  class="focusable"
  [(value)]="time"
  (ngModelChange)="changeModelState()"
  (blur)="onblurEvent()"
  [required]="requiredValue"
  [readonly]="disabledValue"
  [min]="minValue"
  openOnFieldClick="true"
  (onFocusOut)="onblurEvent()"
  (onFocusIn)="onFocusIn()"
  (onInitialized)="onInitialized.emit($event)"
  [disabled]="disabledValue">
</dx-date-box>
